import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { usePortalTooltip } from "../../hooks/usePortalTooltip.js";

// Shared sidebar building blocks used by both the main Sidebar and the SettingsSidebar,
// so the two navs render with identical spacing, active-pill, and tooltip behavior.

export const SidebarItem = ({
  url, isOpen, activeTab, setActiveTab, tabName,
  sidebarIcon, tooltip, tooltipDescription, badge,
}) => {
  const isActive = activeTab === tabName;
  const { tooltipProps, TooltipPortal } = usePortalTooltip({
    content: tooltip,
    description: tooltipDescription,
    place: "right",
    delayShow: 500,
  });
  const target = url;

  return (
    <>
      <Link to={target} className="block" onClick={() => setActiveTab(tabName)} {...tooltipProps}>
        <div className={`relative my-[2px] flex items-center gap-3 rounded-ctrl py-2.5 transition-colors cursor-pointer ${
          isOpen
            ? isActive ? "ml-[2px] mr-3 pl-[26px] pr-4" : "mx-3 px-4"
            : "mx-3 px-4 justify-center"
        } ${
          isActive ? "bg-surface text-text font-semibold shadow-[0_0_0_7px_hsl(var(--side))]" : "text-text-2 hover:bg-side-2"
        }`}>
          <div className="relative flex-none">
            <FontAwesomeIcon
              title={tabName}
              icon={sidebarIcon}
              className={`w-[18px] text-[16px] ${isActive ? "text-text" : "text-text-3"}`}
            />
            {!isOpen && badge != null && badge > 0 && (
              <span className="absolute -top-1.5 -right-1.5 flex items-center justify-center min-w-[14px] h-[14px] px-0.5 rounded-full text-[9px] font-bold bg-danger text-white">
                {badge > 99 ? "99+" : badge}
              </span>
            )}
          </div>
          {isOpen && <span className="text-sm flex-1">{tabName}</span>}
          {isOpen && badge != null && badge > 0 && (
            <span className="inline-flex items-center justify-center min-w-[20px] h-[20px] px-1.5 rounded-full text-[11px] font-bold bg-danger text-white">
              {badge > 99 ? "99+" : badge}
            </span>
          )}
        </div>
      </Link>
      <TooltipPortal />
    </>
  );
};

export const Group = ({ label, isOpen, children }) => (
  <div className="mb-4">
    {isOpen && (
      <div className="px-7 pb-1.5 text-[10.5px] font-bold tracking-[0.08em] uppercase text-text-3">
        {label}
      </div>
    )}
    {isOpen ? (
      <div className="relative pl-[21px]">
        <span className="pointer-events-none absolute inset-y-4 left-[37px] border-l border-[hsl(214_22%_84%)]" aria-hidden="true" />
        {children}
      </div>
    ) : (
      children
    )}
  </div>
);
